/**
 *
 * UiControl
 * Simple container to make change to Redux state
 * Add 'prop' string to indicate which property of state.ui will be changed
 * children will have onClick/onChange handlers
 * Set inital value in reducer
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// import debounce from 'lodash.debounce';

import { uiToggle, uiSet } from './actions';
import makeSelectUiControl from './selectors';

export const mapStateToProps = props => {
  const propSelectors = props.reduce(
    (acc, prop) => ({
      ...acc,
      [prop]: makeSelectUiControl(prop),
    }),
    {},
  );
  return createStructuredSelector(propSelectors);
};

export function mapDispatchToPropsMulti(dispatch) {
  return {
    uiToggle: prop => () => dispatch(uiToggle(prop)),
    uiChange: prop => value => dispatch(uiSet(prop, value)),
  };
}

export function mapDispatchToProps(prop) {
  return dispatch => ({
    uiToggle: () => dispatch(uiToggle(prop)),
    uiChange: value => dispatch(uiSet(prop, value)),
  });
}

function withUiControl(props) {
  if (Array.isArray(props)) {
    return connect(
      mapStateToProps(props),
      mapDispatchToPropsMulti,
    );
  }
  return connect(
    mapStateToProps([props]),
    mapDispatchToProps(props),
  );
}

export default withUiControl;
